<template>
  <transition name="fade" appear>
    <div class="login-container">
      <div class="logo-section">
        <img src="../assets/logo.png" alt="logo" class="logo" />
      </div>

      <div class="form-section">
        <div class="form-group">
          <label class="form-label">登录账号</label>
          <div class="input-wrapper">
            <img src="../assets/account-icon.png" alt="user" class="input-icon" />
            <input type="text" v-model="username" placeholder="请输入登录账号" class="form-input" />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">登录密码</label>
          <div class="input-wrapper">
            <img src="../assets/password-icon.png" alt="password" class="input-icon" />
            <input type="password" v-model="password" placeholder="请输入登录密码" class="form-input" />
          </div>
        </div>

        <button class="login-btn" @click="handleLogin">登录</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { systemToken } from '../api/apiList/system';

export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: ''
    };
  },
  mounted() {
    // 检测是否已登录
    const token = localStorage.getItem('token');
    if (token) {
      this.$router.replace('/home');
    }
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.$toast('请输入账号和密码')
        return;
      }
      let info = await systemToken({
        username: this.username,
        password: this.password
      })
      if (info.access) {
        localStorage.setItem('token', info.access)
        this.$toast('登录成功')
        setTimeout(() => {
          this.$router.push('/home');
        }, 1000)
      } else {
        this.$toast(info.detail)
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #000;
  background-image: url('../assets/login-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  padding: 60px 20px 40px;
}

.logo-section {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  max-width: 50%;
  height: auto;
  margin-bottom: 20px;
}

.title {
  color: #36D8AF;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 2px;
}

.form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 30px;
}

.form-label {
  display: block;
  color: #fff;
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 400;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  padding: 0 20px;
  backdrop-filter: blur(10px);
}

.input-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  opacity: 0.6;
}

.form-input {
  flex: 1;
  height: 50px;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 15px;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.login-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(180deg, #36D8AF 0%, #10BDA7 100%);
  border: none;
  border-radius: 25px;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: auto;
}

.login-btn:active {
  opacity: 0.8;
}
</style>
